"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var CacheInterface_1 = require("../CacheInterface");
var Config = /** @class */ (function (_super) {
    __extends(Config, _super);
    function Config() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ENV_PREFIX = "VUE_APP_";
        return _this;
    }
    /**
     * Initialize the Environment variables into the
     * application as configuration variables
     */
    Config.prototype.initEnv = function () {
        if (process.env) {
            var env = process.env;
            for (var i in env) {
                if (i.startsWith(this.ENV_PREFIX)) {
                    var key = i.substr(this.ENV_PREFIX.length);
                    var value = env[i];
                    if (typeof value === "string") {
                        if (value.toLowerCase() === "true") {
                            value = true;
                        }
                        else if (value.toLowerCase() === "false") {
                            value = false;
                        }
                        else if (!isNaN(value)) {
                            value = parseFloat(value);
                        }
                    }
                    _super.prototype.set.call(this, key, value);
                }
            }
        }
    };
    Config.prototype.isDev = function () {
        if (process &&
            process.hasOwnProperty("env") &&
            process.env.hasOwnProperty("NODE_ENV")) {
            if (process.env.Node_ENV !== "undefined") {
                return process.env.NODE_ENV === "development";
            }
        }
        return false;
    };
    return Config;
}(CacheInterface_1.CacheInterface));
exports.default = Config;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvQ29uZmlnL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBLG9EQUFtRDtBQUVuRDtJQUFvQywwQkFBYztJQUFsRDtRQUFBLHFFQTBDQztRQXpDUSxnQkFBVSxHQUFHLFVBQVUsQ0FBQzs7SUF5Q2pDLENBQUM7SUF2Q0M7OztPQUdHO0lBQ0ksd0JBQU8sR0FBZDtRQUNFLElBQUksT0FBTyxDQUFDLEdBQUcsRUFBRTtZQUNmLElBQU0sR0FBRyxHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUM7WUFFeEIsS0FBSyxJQUFNLENBQUMsSUFBSSxHQUFHLEVBQUU7Z0JBQ25CLElBQUksQ0FBQyxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLEVBQUU7b0JBQ2pDLElBQU0sR0FBRyxHQUFHLENBQUMsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxNQUFNLENBQUMsQ0FBQztvQkFDN0MsSUFBSSxLQUFLLEdBQUcsR0FBRyxDQUFDLENBQUMsQ0FBUSxDQUFDO29CQUMxQixJQUFJLE9BQU8sS0FBSyxLQUFLLFFBQVEsRUFBRTt3QkFDN0IsSUFBSSxLQUFLLENBQUMsV0FBVyxFQUFFLEtBQUssTUFBTSxFQUFFOzRCQUNsQyxLQUFLLEdBQUcsSUFBSSxDQUFDO3lCQUNkOzZCQUFNLElBQUksS0FBSyxDQUFDLFdBQVcsRUFBRSxLQUFLLE9BQU8sRUFBRTs0QkFDMUMsS0FBSyxHQUFHLEtBQUssQ0FBQzt5QkFDZjs2QkFBTSxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQVksQ0FBQyxFQUFFOzRCQUMvQixLQUFLLEdBQUcsVUFBVSxDQUFDLEtBQUssQ0FBQyxDQUFDO3lCQUMzQjtxQkFDRjtvQkFDRCxpQkFBTSxHQUFHLFlBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxDQUFDO2lCQUN2QjthQUNGO1NBQ0Y7SUFDSCxDQUFDO0lBRU0sc0JBQUssR0FBWjtRQUNFLElBQ0UsT0FBTztZQUNQLE9BQU8sQ0FBQyxjQUFjLENBQUMsS0FBSyxDQUFDO1lBQzdCLE9BQU8sQ0FBQyxHQUFHLENBQUMsY0FBYyxDQUFDLFVBQVUsQ0FBQyxFQUN0QztZQUNBLElBQUksT0FBTyxDQUFDLEdBQUcsQ0FBQyxRQUFRLEtBQUssV0FBVyxFQUFFO2dCQUN4QyxPQUFPLE9BQU8sQ0FBQyxHQUFHLENBQUMsUUFBUSxLQUFLLGFBQWEsQ0FBQzthQUMvQztTQUNGO1FBQ0QsT0FBTyxLQUFLLENBQUM7SUFDZixDQUFDO0lBQ0gsYUFBQztBQUFELENBQUMsQUExQ0QsQ0FBb0MsK0JBQWMsR0EwQ2pEIn0=